import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconCapitalLetterY = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M15.2365 8.00037L12.3085 13.0644V16.4004H10.9285V13.0644L8.00049 8.00037H9.57249L11.6245 11.7204L13.6645 8.00037H15.2365Z" }),
});

export { IconCapitalLetterY };
